import React from 'react';
import { CloudDownload } from 'lucide-react';
import { Badge } from '../ui/Badge.js';
import type { TabSong } from '../../types/index.js';

/** FRE-142: backup state of a private import, or "not downloaded yet" for restored cloud tabs. First match wins. */
export const TabBackupBadge: React.FC<{ tab: TabSong; isGuest: boolean }> = ({ tab, isGuest }) => {
  const pending = tab.pendingUpload === 1;

  if (pending && tab.uploadBlocked === 1) {
    const title =
      tab.uploadError === 'too_large'
        ? 'حجم فایل بیشتر از حد مجاز سرور است.'
        : 'سرور این فایل را نپذیرفت.';
    return (
      <span title={title} data-testid={`tab-backup-badge-${tab.id}`} data-state="failed">
        <Badge tone="error" size="sm">
          پشتیبان‌گیری ناموفق
        </Badge>
      </span>
    );
  }
  if (pending && isGuest) {
    return (
      <span
        title="برای پشتیبان‌گیری وارد حساب کاربری شوید."
        data-testid={`tab-backup-badge-${tab.id}`}
        data-state="local"
      >
        <Badge tone="neutral" size="sm">
          فقط روی این دستگاه
        </Badge>
      </span>
    );
  }
  if (pending) {
    return (
      <span
        title="با اتصال به اینترنت در حساب شما ذخیره می‌شود."
        data-testid={`tab-backup-badge-${tab.id}`}
        data-state="pending"
      >
        <Badge tone="warning" size="sm">
          در انتظار پشتیبان‌گیری
        </Badge>
      </span>
    );
  }
  if (!tab.localBlob) {
    return (
      <span title="با اولین باز کردن دانلود می‌شود." data-testid={`tab-cloud-badge-${tab.id}`}>
        <Badge tone="neutral" size="sm" className="hidden md:inline-flex">
          <span className="inline-flex items-center gap-1">
            <CloudDownload className="size-3" aria-hidden="true" />
            دانلود نشده
          </span>
        </Badge>
        <span className="md:hidden inline-flex items-center" title="دانلود نشده">
          <CloudDownload className="size-3.5 text-base-content/40 shrink-0" aria-label="دانلود نشده" />
        </span>
      </span>
    );
  }
  return null;
};

TabBackupBadge.displayName = 'TabBackupBadge';
